import React, { memo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Logo from 'design-system/Logo';
import { rem, Spacer } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { usePosition } from '../hooks';
import { formatNumberOfShares } from '../utils';
import { useStockMeta } from '../hooks/selectors';
const SellAssetRow = ({ assetId }) => {
    const styles = useStyles(styleSet);
    const stockCache = useStockMeta(assetId);
    const [position] = usePosition(assetId, true);
    return (<TouchableBounceCard onDark disabled noMarginTop noMarginBottom style={styles.cardBtn}>
      <View style={styles.row}>
        <Logo R44 uri={stockCache?.iconUrl} resizeMode="contain"/>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16 numberOfLines={1}>
            {stockCache?.name}
          </Text>
          <Text TextThin-14 Secondary>
            {formatNumberOfShares(position?.availableToSell || 0, true)} available
          </Text>
        </View>
      </View>
    </TouchableBounceCard>);
};
const styleSet = createStyleSheets(() => ({
    cardBtn: {
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
}));
export default memo(SellAssetRow);
